<template>
  <div class="col">
    <div class="row mt-3">
      <div class="col-lg-12">
        <form
          @submit="searchFeaturedHistory"
        >
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-2">
                  <h4>Featured History</h4>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Login:
                  </label>
                  <input
                    v-model="formSearch.login"
                    type="text"
                    class="form-control"
                    placeholder="e.g. 1casa"
                  >
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Property:
                  </label>
                  <input
                    v-model="formSearch.property"
                    type="text"
                    class="form-control"
                    placeholder="e.g. 1234567"
                  >
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                class="btn btn-secondary float-left"
                type="reset"
                @click.prevent="resetFilters"
              >
                Clear All Filters
              </button>
              <button
                type="submit"
                class="btn btn-primary float-right"
              >
                <i class="jam jam-search" /> Search
              </button>
            </div>
          </div>
        </form>

        <div
          class="row mt-3"
          v-if="history"
        >
          <div class="col-12">
            <div class="table mt-4">
              <table
                class="w-100 pb-4 pt-4 responsive white-space table-striped"
              >
                <thead>
                  <tr>
                    <th>
                      Login
                    </th>
                    <th>
                      Property
                    </th>
                    <th>
                      Date
                    </th>
                    <th>
                      Operation
                    </th>
                    <th>
                      By
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(entry, i) in history"
                    :key="i"
                  >
                    <td>{{ entry.login }}</td>
                    <td>
                      <a
                        :href="`https://www.thinkspain.com/property-for-sale/${entry.propertyId}`"
                      >
                        {{ entry.propertyId }}
                      </a>
                    </td>
                    <td> {{ toLocalTime( entry.date ) }} </td>
                    <td>
                      <template v-if="entry.featured">
                        <span class="badge badge-success">Featured</span>
                      </template>
                      <template v-else-if="entry.premium">
                        <span class="badge badge-primary">Premium</span>
                      </template>
                      <template v-else>
                        <span class="badge badge-danger">Unfeatured</span>
                      </template>
                    </td>
                    <td>
                      <template v-if="entry.process == 0">
                        Client Panel
                      </template>
                      <template v-else-if="entry.process == 5100">
                        Xml Feed Import Process<br>
                        <sub>most likely property went offline</sub>
                      </template>
                      <template v-else-if="entry.process == 9000">
                        Auto Featured Selection Process
                      </template>
                      <template v-else>
                        {{ entry.process }}
                      </template>
                    </td>
                  </tr>
                </tbody>
                <tfoot />
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../../../http';
import notify from '../../../../notifications';

let getDefaultFilters = function() {
    return {
        login: '',
        property: null
    };
};

export default {
    data() {
        return {
            formSearch: getDefaultFilters(),
            history: null
        };
    },
    methods: {
        async searchFeaturedHistory( e ) {
            e.preventDefault();
            this.$store.dispatch( 'appLoading', true );

            var toSend = {
                login: this.formSearch.login
            };

            // Ensure propertyId is sent as an integer
            if ( this.formSearch.property ) {
                toSend.property = parseInt( this.formSearch.property, 10 );
            }

            const response = await http.post( '/featuredhistory', toSend );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    title: 'Something went wrong',
                    text: 'Please try again'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            const data = await response.json();

            this.history = data;

            this.$store.dispatch( 'appLoading', false );

            // Update the URL with query parameters
            const queryParams = {};
            if ( this.formSearch.login && this.formSearch.login.length > 0 ) {
                queryParams.login = this.formSearch.login;
            }
            if ( this.formSearch.property ) {
                queryParams.property = this.formSearch.property;
            }
            this.$router.push( { query: queryParams } );
        },
        toLocalTime( utcTime ) {
            return new Date( utcTime ).toLocaleString( 'es-ES', {
                timeZone: 'Europe/Madrid',
                timeZoneName: 'short'
            } );
        },
        resetFiltersToDefaults() {
            this.formSearch = getDefaultFilters();
        },
        resetFilters() {
            this.formSearch = getDefaultFilters();
        },
        initializeFiltersFromQuery() {
            // Read query parameters from the URL
            const { login, property } = this.$route.query;

            if ( login ) {
                this.formSearch.login = login;
            }

            if ( property ) {
                this.formSearch.property = parseInt( property, 10 ); // Ensure property is an integer
            }

            // Automatically trigger the search if query parameters are present
            if ( login || property ) {
                this.searchFeaturedHistory();
            }
        }
    },
    mounted() {
        document.title = 'thinkSPAIN - Featured History';
        this.initializeFiltersFromQuery();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/featuredhistory/form/index.vue